import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo-wrapper">
        <NavLink to="/" onClick={() => setIsOpen(false)}>
          <img src={logo} alt="That's A Dumb Rule? Podcast" className="navbar-logo" />
        </NavLink>
      </div>

      <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
        <span className={`bar ${isOpen ? 'open' : ''}`}></span>
        <span className={`bar ${isOpen ? 'open' : ''}`}></span>
        <span className={`bar ${isOpen ? 'open' : ''}`}></span>
      </button>

      <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
        <li><NavLink to="/" end onClick={() => setIsOpen(false)}>Home</NavLink></li>
        <li><NavLink to="/episodes" onClick={() => setIsOpen(false)}>Episodes</NavLink></li>
        <li><NavLink to="/about" onClick={() => setIsOpen(false)}>About</NavLink></li>
        <li><NavLink to="/contact" onClick={() => setIsOpen(false)}>Contact</NavLink></li>
      </ul>
    </nav>
  );
};

export default Navbar;